/**
 * Hero: GSAP entrance and parallax. Dual-trigger pattern (DOMContentLoaded AND
 * document.fonts.ready) prevents FOUC on the h1. Parallax disabled below lg and
 * on prefers-reduced-motion.
 */
import { gsap } from 'gsap';

(function () {
    'use strict';

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var domReady = false;
    var fontsReady = false;

    function tryInit() {
        if (!domReady || !fontsReady) return;
        if (prefersReduced) return;
        setTimeout(initAnimations, 80);
    }

    document.addEventListener('DOMContentLoaded', function () {
        domReady = true;
        tryInit();
    });

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { fontsReady = true; tryInit(); });
    } else {
        window.addEventListener('load', function () { fontsReady = true; tryInit(); });
    }

    function initAnimations() {
        var hero = document.querySelector('.mnhq-hero');
        if (!hero) return;

        var image = hero.querySelector('.mnhq-hero__image');
        var statTopRight = hero.querySelector('.mnhq-hero__stat--top-right');
        var statBottomLeft = hero.querySelector('.mnhq-hero__stat--bottom-left');

        // Parallax (xl+ only — image visible only above 1280)
        if (!window.matchMedia('(min-width: 1280px)').matches) return;
        if (!image) return;

        var xToImage   = gsap.quickTo(image,          'x', { duration: 0.7, ease: 'power3.out' });
        var yToImage   = gsap.quickTo(image,          'y', { duration: 0.7, ease: 'power3.out' });
        var xToTop     = statTopRight    ? gsap.quickTo(statTopRight,    'x', { duration: 0.7, ease: 'power3.out' }) : null;
        var yToTop     = statTopRight    ? gsap.quickTo(statTopRight,    'y', { duration: 0.7, ease: 'power3.out' }) : null;
        var xToBottom  = statBottomLeft  ? gsap.quickTo(statBottomLeft,  'x', { duration: 0.7, ease: 'power3.out' }) : null;
        var yToBottom  = statBottomLeft  ? gsap.quickTo(statBottomLeft,  'y', { duration: 0.7, ease: 'power3.out' }) : null;

        var startListening = function () {
            window.addEventListener('mousemove', function (e) {
                var mx = (e.clientX / window.innerWidth - 0.5) * 2;
                var my = (e.clientY / window.innerHeight - 0.5) * 2;
                xToImage(mx * -3);
                yToImage(my * -3);
                if (xToTop)    { xToTop(mx * 7);  yToTop(my * -5); }
                if (xToBottom) { xToBottom(mx * 6); yToBottom(my * 5); }
            }, { passive: true });
        };
        // Hold rest position briefly so cards transition in from origin on load
        setTimeout(startListening, 700);
    }
})();
